import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronsLeft, Lock, LogOut, User as UserIcon } from "react-feather";
import logo from "../../core/img/texas-alarms-logo.jpg";
import logoMark from "../../core/img/texas-alarms-mark.png";
import { useClaims } from "../../features/auth/useClaims";
import { useLogout } from "../../features/auth/useLogout";
import { paths } from "../../routes/paths";
import BranchPicker from "./BranchPicker";
import HeaderQuickAccess from "./HeaderQuickAccess";
import NotificationBell from "./NotificationBell";

const Header = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { fullName, username, designation, roles } = useClaims();
  // Shows the user's HR designation (job title) rather than their RBAC role
  // name - falls back to the role for accounts with no designation set
  // (service accounts, or an employee-linked user whose HR record has no
  // job title), so this never renders blank for someone who does have a role.
  const displayTitle = designation || roles?.[0] || "";
  const logout = useLogout();

  const toggleSidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    setCollapsed((v) => !v);
  };

  const toggleMobileNav = () => {
    document.querySelector(".main-wrapper")?.classList.toggle("slide-nav");
    document.querySelector(".sidebar-overlay")?.classList.toggle("opened");
    document.querySelector("html")?.classList.toggle("menu-opened");
  };

  return (
    <div className="header">
      <div className={`header-left ${collapsed ? "" : "active"}`}>
        <Link to={paths.dashboard} className="logo logo-normal">
          <img src={logo} alt="Texas Alarms" />
        </Link>
        <Link to={paths.dashboard} className="logo-small">
          <img src={logoMark} alt="Texas Alarms" />
        </Link>
        <Link id="toggle_btn" to="#" onClick={toggleSidebar}>
          <ChevronsLeft className="feather-16" />
        </Link>
      </div>

      <Link
        id="mobile_btn"
        className="mobile_btn"
        to="#"
        onClick={toggleMobileNav}
      >
        <span className="bar-icon">
          <span />
          <span />
          <span />
        </span>
      </Link>

      <ul className="nav user-menu align-items-center justify-content-end">
        <HeaderQuickAccess />
        <li className="nav-item">
          <BranchPicker />
        </li>
        {/* Same top-right spot the Flutter app puts its bell in, and immediately
            left of the profile menu so the two "about me" controls sit together. */}
        <NotificationBell />
        <li className="nav-item dropdown has-arrow main-drop">
          <Link
            to="#"
            className="dropdown-toggle nav-link userset"
            data-bs-toggle="dropdown"
          >
            <span className="user-info">
              <span className="user-letter">
                <UserIcon size={18} />
              </span>
              <span className="user-detail">
                <span className="user-name">{fullName || username}</span>
                <span className="user-role">{displayTitle}</span>
              </span>
            </span>
          </Link>
          <div className="dropdown-menu menu-drop-user">
            <div className="profilename">
              <div className="profileset">
                <div className="profilesets">
                  <h6>{fullName || username}</h6>
                  <h5>{displayTitle}</h5>
                </div>
              </div>
              <hr className="m-0" />
              <Link to={paths.changePassword} className="dropdown-item">
                <Lock className="me-2" size={16} />
                Change Password
              </Link>
              <button
                type="button"
                className="dropdown-item logout pb-0 border-0 bg-transparent w-100 text-start"
                onClick={logout}
              >
                <LogOut className="me-2" size={16} />
                Logout
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Header;
